export default __webpack_public_path__ + "static/media/27.ae9e80dd.gif";